
import { defineComponent, PropType } from 'vue';
import arrowShapeDesktop from '@/assets/img/landingpage-customer/user-carousel/arrow-shape.svg';
import arrowShapeMobile from '@/assets/img/landingpage-customer/user-carousel/arrow-shape-mobile.svg';

export default defineComponent({
  name: 'LPUserCarouselArrow',
  props: {
    direction: {
      type: String as PropType<'left' | 'right'>,
      default: 'left'
    },
    variant: {
      type: String as PropType<'desktop' | 'mobile'>,
      default: 'desktop'
    },
    ariaLabel: {
      type: String,
      required: true
    }
  },
  emits: ['activate'],
  setup(props) {
    return {
      arrowShape: props.variant === 'mobile' ? arrowShapeMobile : arrowShapeDesktop
    };
  }
});
